import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Tiptap, TiptapToolbar } from '@/components/ui/tiptap-editor';
import { useGetQuizTiptapExtensionBuilderSet } from '@/hooks/quiz';

export function QuestionContentFormField(questionContentFormFieldProps: ComponentProps<typeof FormItem>) {
  const { className, ...props } = questionContentFormFieldProps;
  const extensions = useGetQuizTiptapExtensionBuilderSet();

  return (
    <FormField
      name={'content'}
      render={({ field }) => (
        <FormItem {...props} className={cn(className)}>
          <FormControl>
            <Tiptap
              {...field}
              extensions={extensions}
              className="p-3"
              placeholder="Treść pytania..."
              onUpdate={(res) => {
                if (res.editor.isEmpty) {
                  field.onChange('');
                  return;
                }
                field.onChange(res.editor.getHTML());
              }}
              content={field.value}
            >
              <TiptapToolbar className={'justify-start p-3'} />
            </Tiptap>
          </FormControl>
          <FormMessage className="px-3 pb-3" />
        </FormItem>
      )}
    />
  );
}
